import COTimezone from '@components/FigmaComponents/COTimezone.tsx';

interface ComponentProps {
  number?: string;
  address?: string | JSX.Element;
  company?: string;
  timezoneId?: string;
  dataTestIdLocationName?: string;
}

const TimeslotsProgressTitle: React.FC<ComponentProps> = ({ number, address, company, timezoneId, dataTestIdLocationName }) => {
  return (
    <div className="timeslotsProgress__title p-d-flex">
      <div className="number">{number}</div>
      <div>
        <div className="timeslots-address flex items-center gap-2">
          {address}
          <COTimezone dataTestId={`${dataTestIdLocationName}-timezone`} timezoneId={timezoneId} />
        </div>
        <div className="timeslots-company">
          <small className="text-gray5" data-testid={`${dataTestIdLocationName}-locationName`}>{company}</small>
        </div>
      </div>
    </div>
  );
};
export default TimeslotsProgressTitle;
